import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_back",
  "use": "icon-ic_back-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-ic_back\"><path d=\"M12.787 18.17c.198.198.45.306.748.306.596 0 1.074-.469 1.074-1.064 0-.297-.127-.568-.334-.775l-6.313-6.17 6.313-6.15a1.11 1.11 0 0 0 .334-.776c0-.596-.478-1.065-1.074-1.065-.297 0-.55.109-.748.307L5.77 9.638c-.253.234-.37.523-.379.838 0 .316.126.587.379.83l7.017 6.864z\" fill=\"#1E1E1E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol